<script>
  import Cashback from '$components/+cashback.svelte';
  import Sections from '$components/+sections.svelte';
  import { modifyImageUrl } from '$utils/formatters';
  import Seo from '$components/+seo.svelte';
  import { page } from '$app/stores';

  /** @type {import('./$types').PageData} */
  export let data;
</script>

<Seo title={data.name} noindex nofollow />

<article id={data.slug} class="content campaign-content" data-uuid={data.uuid}>
  <div class="wrap">
    <div class="header">
      <h1>{data.name}</h1>
    </div>

    <div class="hero">
      <img src={modifyImageUrl(data.images?.banner, { width: 900 })} alt={data?.name} />
      {#if data.cashback_text && !data.hide_cashback}
        <Cashback cashback_text={data.cashback_text} position="corner" size="large" />
      {:else if !data.hide_cashback}
        <Cashback cashback={data.first_time_cashback} position="corner" size="large" />
      {/if}
    </div>

    <div class="description">
      {@html data.description}

      <div class="link">
        <a href={data.link}>{data.link_text}</a>
      </div>
    </div>
  </div>

  {#key $page.params.slug}
    <Sections sections={data.related} />
  {/key}
</article>
